import React from 'react';

import Config from '../../config.js';
import NationalReportsList from './NationalReportsList';
import {
  CountrySelect,
  RegionalGroupSelect,
  YearSelect
} from '../Selects';

class NationalReports extends React.Component {
  constructor(props) {
    super(props);
    const initialState = {
      country: null,
      group: null,
      year: Config.reportYear
    };

    Object.assign(initialState, props.query);

    this.state = initialState;
  }

  onCountrySelect(country) {
    this.setState({
      country: country,
      year: null,
      group:null
    });
  }

  onGroupSelect(group) {
    this.setState({ group, country:null, year: this.state.year });
  }

  onYearSelect(year) {
    this.setState({
      year: year,
      country: null,
      group: null,
    });
  }

  render() {
    return (
      <div>
        <div className="footnote">
        <p>*Links to attached documents, annexes and hard-copy submissions, if any, are created at the bottom of each PDF report.</p>
        </div>
        <div className="row">
          <div className="col-sm-4">
            <YearSelect
              start={ 2002 }
              step={ 2 }
              value={ this.state.year }
              onSelect={ selected => this.onYearSelect(selected.value) }
            />
          </div>
          <div className="col-sm-4">
            <CountrySelect
              onSelect={ selected => this.onCountrySelect(selected.value) }
              value={ this.state.country }
            />
          </div>
          <div className="col-sm-4">
            <RegionalGroupSelect
              className="country-select-list"
              value={ this.state.group }
              textForTotal="All States"
              onChange={ selected => this.onGroupSelect(selected.regionalGroup) }
            />
            </div>

        </div>
        <div className="row">
          <div className="col-sm-12">
            <NationalReportsList
              country={ this.state.country }
              group={ this.state.group }
              year={ this.state.year }
            />
          </div>
        </div>
      </div>
    );
  }
}

export default NationalReports;



// WEBPACK FOOTER //
// ./src/components/NationalReports/NationalReports.js